import React from "react";
import DefaultInvoice from "./DefaultInvoice";
import Invoice1 from "./Invoice1";
import Invoice2 from "./Invoice2";
import Invoice3 from "./Invoice3";
import Invoice3WithVat from "./Invoice3WithVat";
import Invoice3WithTax from "./Invoice3WithTax";
import Invoice4 from "./Invoice4";
import KOT from "./KOT";
import { extractPrinterData } from "../../config/helperFunctions";

function InvoiceMain({ setting, invoiceDetails, handlePrint }) {
  const invoiceSetting = JSON.parse(
    setting.filter((set) => set.type === "invoice_settings")[0].value
  );
  const logo = JSON.parse(
    setting.filter((set) => set.type === "logo")[0].value
  );
  const general = JSON.parse(
    setting.filter((set) => set.type === "general")[0].value
  );

  const printerSettings = JSON.parse(
    setting.filter((set) => set.type === "printer_settings")[0].value
  );

  let InvoiceComponent;

  if (invoiceSetting.invoice === "Default") {
    InvoiceComponent = DefaultInvoice;
  } else if (invoiceSetting.invoice === "Invoice 1") {
    InvoiceComponent = Invoice1;
  } else if (invoiceSetting.invoice === "Invoice 2") {
    InvoiceComponent = Invoice2;
  } else if (invoiceSetting.invoice === "Invoice 3") {
    InvoiceComponent = Invoice3;
  } else if (invoiceSetting.invoice === "Invoice 3 with VAT") {
    InvoiceComponent = Invoice3WithVat;
  } else if (invoiceSetting.invoice === "Invoice 3 with Tax") {
    InvoiceComponent = Invoice3WithTax;
  } else if (invoiceSetting.invoice === "Invoice 4") {
    InvoiceComponent = Invoice4;
  }

  const printingType = printerSettings.printing_type;

  const multiKOTData = extractPrinterData(invoiceDetails, printingType);
  
  let tobacoVat = 0;

  if (invoiceDetails.order_details?.some((item) => item.food_menu.is_tax_fix === "yes")) {
    tobacoVat = invoiceDetails?.order_details?.reduce((acc, item) => {
      if (item.food_menu.is_tax_fix === "yes") {
        return acc + item.menu_taxes.additional_vat;
      }
      return 0;
    }, 0);
  }

  invoiceDetails.tobaco_vat = tobacoVat;

  return (
    <>
      {InvoiceComponent && (
        <InvoiceComponent
          logo={logo.logo_image_base64}
          general={general}
          data={invoiceDetails}
          invoice={invoiceSetting}
          handlePrint={handlePrint}
        />
      )}
      {console.log(multiKOTData)}
      {multiKOTData &&
        Object.keys(multiKOTData).length > 0 &&
        Object.keys(multiKOTData).map((key) => {
          const printerName = key;
          const data = multiKOTData[key];
          return (
            <div key={printerName}>
              <div className="page-break" />
              <KOT
                basicInfo={invoiceDetails}
                data={data}
                printer={printerName}
                handlePrint={handlePrint}
                invoice={invoiceSetting}
              />
            </div>
          );
        })}
    </>
  );
}

export default InvoiceMain;
